import {
  fetchChatMessageReactionDetails as fetchChatMessageReactionDetailsViaApi,
  toggleChatMessageReaction as toggleChatMessageReactionViaApi,
} from '../../../../api/chatReactions';

const buildReactionPath = ({ mode = 'admin', scope = 'individual', artistId, eventId, threadId, messageId }) => {
  if (!messageId) throw new Error('messageId is required');
  if (scope === 'group') {
    if (!threadId) throw new Error('threadId is required');
    return `/api/${mode}/group-chat/threads/${encodeURIComponent(threadId)}/reactions/${encodeURIComponent(messageId)}`;
  }
  if (scope === 'event') {
    if (!eventId) throw new Error('eventId is required');
    return `/api/event-chat/events/${encodeURIComponent(eventId)}/reactions/${encodeURIComponent(messageId)}`;
  }
  if (mode === 'artist') {
    return `/api/artist/messages/reactions/${encodeURIComponent(messageId)}`;
  }
  if (!artistId) throw new Error('artistId is required');
  return `/api/admin/messages/${encodeURIComponent(artistId)}/reactions/${encodeURIComponent(messageId)}`;
};

export const fetchChatMessageReactionDetails = async (params, { signal } = {}) => {
  buildReactionPath(params);
  return fetchChatMessageReactionDetailsViaApi(params, { signal });
};

export const toggleChatMessageReaction = async (params) => {
  buildReactionPath(params);
  return toggleChatMessageReactionViaApi(params);
};
